import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import Media from "react-media";
import Cookies from "universal-cookie";

import styles from "./styles.m.css";
import { WebEngage, GA, DeepBI, PGAD, EVOLOK } from "../../../integrations";

import { getPWD, EncryptData } from "../../utils/utils";
// import Toolbar from "./toolbar";

import PdfViewer from "./pdf-viewer";

const cookies = new Cookies();

export const PDFPage = ({ pageType, config, data: { collection, magazine, apiKey, v2Key, url } }) => {
  useEffect(() => {
    const handleContextMenu = e => {
      e.preventDefault();
    };
    document.addEventListener("contextmenu", handleContextMenu);
    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
    };
  }, []);

  React.useEffect(() => {
    WebEngage.registerPageView();
    GA.registerPageView(pageType || "magazine-page", { collection });
    DeepBI.registerPageView({
      collection: { data: { collection: collection }, pageType: pageType || "magazine-page" }
    });
    PGAD.loadScript();
  }, []);
  if (!collection) return null;

  const [evAccess, setEvAccess] = useState("REQUIRED_LOGIN");
  const [evLoad, setevLoad] = useState(true);
  const mName = get(magazine, ["name"]);
  const issueDate = get(collection, ["collection-date"]);
  const collectionId = get(collection, ["id"], "");
  const mID = get(magazine, ["id"], "");
  const vuid = cookies.get("vuid") ? EncryptData(apiKey, cookies.get("vuid")) : "";
  const [user, setUser] = useState();

  const isSpecialMagazine = get(magazine, ["name"]) === "தீபாவளி மலர்";

  useEffect(() => {
    EVOLOK.loadScript("magazine-page", { collection: collection }, handleMeteringSuccess);

    global.userPromise.catch(() => ({})).then(user => {
      user && setUser(user);
    });
  }, []);

  const handleMeteringSuccess = response => {
    if (response.result === "ALLOW_ACCESS") {
      DeepBI.PingOnlinePDFView(collection, mName, issueDate, mID, 1, collectionId);
    } else {
      DeepBI.PingPDF(collection, mName, issueDate, mID, "PDFPaywallDisplayed");
    }
    setEvAccess(response.result);

    setevLoad(false);
  };

  const handleClickAction = number => {
    DeepBI.PingOnlinePDFView(collection, mName, issueDate, mID, number, collectionId);
  };

  const collectionImage = get(collection, ["metadata", "cover-image", "url"], "");
  const pdfPassword = getPWD(apiKey, v2Key);
  const currentTimestamp = Math.floor(Date.now() / 1000);
  const collectionDate = get(collection, ["collection-date"], "");

  const entityId = get(magazine, ["id"], "");
  const combineDate = collectionDate / 1000 - 19800;
  const getDate = EncryptData(apiKey, combineDate.toString());
  const encrypCurrentTimestamp = `${currentTimestamp}-pdf_vikatan`;

  const domainName = global && global.location && global.location.origin;

  const pdfURLPath = `${domainName}/pdf-view?v=${EncryptData(apiKey, encrypCurrentTimestamp)}&z=${EncryptData(
    apiKey,
    entityId.toString()
  )}_${getDate}_${EncryptData(apiKey, collectionId.toString())}.pdf`;

  const handleLoginClick = () => {
    const redirectUrl = global && global.location && global.location.href;
    window.location.href = `${domainName}/user/login?&utm_source=Paywall&utm_medium=webpdf&utm_campaign=paywall_experiment&redirect_url=${redirectUrl}`;
    DeepBI.PingPDF(collection, mName, issueDate, mID, "PDF-paywall-login-clicked");
  };

  const handleSubscribeClick = () => {
    const redirectUrl = global && global.location && global.location.href;
    window.location.href = `${domainName}/store?utm_source=direct_web&utm_medium=web&utm_campaign=paywall&redirect_url=${redirectUrl}`;
    DeepBI.PingPDF(collection, mName, issueDate, mID, "PDF-paywall-clicked");
  };

  const handleBuyNowClick = () => {
    const redirectUrl = global && global.location && global.location.href;
    const newWindow = window.open("", "_blank");
    newWindow.location.href = `https://store.vikatan.com/vikatan-diwali-malar/?utm_source=direct_web&utm_medium=web&utm_campaign=web_pdf_paywall&type=issue&sid=${collectionId}&redirect_url=${redirectUrl}`;
    DeepBI.PingPDF(collection, mName, issueDate, mID, "PDF-paywall-clicked");
  };

  const loggedOutStat = get(user, ["loggedOut"], false);
  return (
    <div className={`${styles["main-container"]} ${styles["pdf-page"]}`}>
      <div className={styles.base}>
        {evLoad !== true && (
          <div>
            {evAccess === "ALLOW_ACCESS" ? (
              <div>
                <Media query="(max-width: 767px)">
                  {matches =>
                    matches && (
                      <div className={styles["customStyles-wrapper"]}>
                        <div className={styles["customStyles"]}>
                          <img src="https://media.vikatan.com/vikatan/2022-10/d90a3e94-d1eb-4d52-8cc6-b7b949ba80ca/magazine_pdf.png" />
                          <div>
                            <strong>
                              இந்த இதழை விகடன் App-ல் மட்டுமே Book Format-ல் படிக்க முடியும். App-ஐ இன்ஸ்டால்
                              செய்கிறீர்களா?
                            </strong>
                            <div className={styles["popup-btns"]}>
                              <a
                                href="https://vikatanmobile.page.link/ReadInBookFormat"
                                className={`${styles["buy-btn"]}`}
                              >
                                Install Now
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    )
                  }
                </Media>
                <Media query="(min-width: 768px)">
                  {matches =>
                    matches && (
                      <PdfViewer
                        pdfPassword={pdfPassword}
                        pdfUrl={pdfURLPath}
                        clickAction={handleClickAction}
                        webView={"webview"}
                        watermarkText={vuid}
                      />
                    )
                  }
                </Media>
              </div>
            ) : isSpecialMagazine ? (
              <div className={`${styles["paywall-container"]} container`}>
                <div className={styles["magazine-pdf-paywall"]}>
                  <div className={styles["magazine-paywall-pdf-wrapper"]}>
                    <img src={collectionImage} />
                  </div>
                  <div className={styles["magazine-paywall"]}>
                    <div className={styles["paywall-option"]}>
                      <div className={styles["premium-header"]}>
                        <h3 className={styles["premium-header-txt"]}>
                          <img src="https://media.vikatan.com/vikatan/2022-07/d60c2e0a-8ce2-4c01-8fee-76bfa6d373d1/premium_icon.png" />
                          இது ஒரு பிரீமியம் இதழ்
                        </h3>
                      </div>
                      <div className={styles["plans-wrapper"]}>
                        <div className={styles["dynamic-paywall"]}>
                          <div className={styles["dynamic-paywall-grid"]}>
                            <div className={styles["diwali-malar"]}>
                              <img src={collectionImage} />
                            </div>
                            <div className={styles["magazine-benefits-list"]}>
                              <div className={styles["dynamic-paywall-content"]}>
                                <ul className={styles["benefits"]}>
                                  <li>
                                    <span className={styles["arrow"]}>&gt;</span>
                                    <span>சினிமா, ஆன்மிகம், பயணம், இலக்கியம், அறிவியல் என பல்சுவைக் கட்டுரைகள்</span>
                                  </li>
                                  <li>
                                    <span className={styles["arrow"]}>&gt;</span>
                                    <span>பல்துறை பிரபலங்களின் பிரத்யேக பேட்டிகள் & படைப்புகள் </span>
                                  </li>
                                  <li>
                                    <span className={styles["arrow"]}>&gt;</span>
                                    <span>பண்டிகைக் காலத்தை இனிமையாக்கிடும் 400 சுவாரஸ்ய பக்கங்கள்</span>
                                  </li>
                                </ul>
                                <p>கீழே கட்டணம் செலுத்தி இப்போதே தீபாவளி மலரைப் படித்து மகிழ்ந்திடுங்கள்!</p>
                              </div>
                            </div>
                          </div>
                          <div className={styles["subs-btns-outer"]}>
                            <div className={styles["subs-btns-wrap-inline"]}>
                              <a
                                className={styles["filled-btn"]}
                                rel="noopener noreferrer"
                                target="_blank"
                                onClick={() => handleBuyNowClick(collection)}
                              >
                                Buy Now
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className={`${styles["paywall-container"]} container`}>
                <div className={styles["magazine-pdf-paywall"]}>
                  <div className={styles["magazine-paywall-pdf-wrapper"]}>
                    <img src={collectionImage} />
                  </div>
                  <div className={styles["magazine-paywall"]}>
                    <div className={styles["paywall-option"]}>
                      <div className={styles["premium-header"]}>
                        <h3 className={styles["premium-header-txt"]}>
                          <img src="https://media.vikatan.com/vikatan/2022-07/d60c2e0a-8ce2-4c01-8fee-76bfa6d373d1/premium_icon.png" />
                          இது ஒரு பிரீமியம் ஸ்டோரி
                        </h3>
                      </div>
                      <div className={styles["plans-wrapper"]}>
                        <div className={styles["dynamic-paywall"]}>
                          <div className={styles["dynamic-paywall-grid"]}>
                            <div>
                              <div className={styles["dynamic-wrapper"]}>
                                <div className={`${styles["panel-img"]} ${styles["left-panel-three"]}`} />
                                <div className={`${styles["panel-img"]} ${styles["left-panel-two"]}`} />
                                <div className={`${styles["panel-img"]} ${styles["left-panel-one"]}`} />
                                <div className={`${styles["panel-img"]} ${styles["center-panel"]}`} />
                                <div className={`${styles["panel-img"]} ${styles["right-panel-one"]}`} />
                                <div className={`${styles["panel-img"]} ${styles["right-panel-two"]}`} />
                                <div className={`${styles["panel-img"]} ${styles["right-panel-three"]}`} />
                              </div>
                            </div>
                            <div className={styles["magazine-benefits-list"]}>
                              <div className={styles["dynamic-paywall-content"]}>
                                <h1>
                                  <span>இந்த {mName}</span> இதழை மட்டுமல்ல...
                                </h1>
                                <ul className={styles["benefits"]}>
                                  <li>
                                    <span className={styles["arrow"]}>&gt;</span>
                                    <span>விகடனின் 8 பிரீமியம் இதழ்கள்</span>
                                  </li>
                                  <li>
                                    <span className={styles["arrow"]}>&gt;</span>
                                    <span>App-ல் புத்தக வடிவில் வாசிப்பனுபவம்</span>
                                  </li>
                                  <li>
                                    <span className={styles["arrow"]}>&gt;</span>
                                    <span>100+ கிளாசிக் தொடர்கள்</span>
                                  </li>
                                  <li>
                                    <span className={styles["arrow"]}>&gt;</span>
                                    <span>1000+ சிறுகதைகள்</span>
                                  </li>
                                </ul>
                                <p>என அன்லிமிட்டட் வாசிப்பனுவத்தைப் பெற இன்றே விகடன் சந்தாதாரராகுங்கள்!</p>
                              </div>
                            </div>
                          </div>
                          <div className={styles["subs-btns-outer"]}>
                            {loggedOutStat ? (
                              <div className={styles["subs-btns-wrap-inline"]}>
                                <a className={styles["outline-btn"]} onClick={() => handleLoginClick(collection)}>
                                  Login
                                </a>
                              </div>
                            ) : (
                              <div />
                            )}
                            <div className={styles["subs-btns-wrap-inline"]}>
                              <a className={styles["filled-btn"]} onClick={() => handleSubscribeClick(collection)}>
                                Subscribe now
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

PDFPage.propTypes = {
  pageType: PropTypes.string,
  config: PropTypes.shape({
    contentInsightsId: PropTypes.string,
    magazines: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        magazineSlug: PropTypes.string,
        name: PropTypes.string,
        url: PropTypes.string,
        vikatanMagazineId: PropTypes.number
      })
    ),
    "publisher-name": PropTypes.string
  }),
  data: PropTypes.shape({
    oldIssues: PropTypes.arrayOf(PropTypes.any),
    config: PropTypes.shape({
      section: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number,
          name: PropTypes.string,
          slug: PropTypes.string
        })
      ),
      magazines: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number,
          magazineSlug: PropTypes.string,
          name: PropTypes.string,
          url: PropTypes.string,
          vikatanMagazineId: PropTypes.number
        })
      ),
      "publisher-name": PropTypes.string
    }),
    collection: PropTypes.shape({
      items: PropTypes.arrayOf(
        PropTypes.shape({
          type: PropTypes.string,
          "associated-metadata": PropTypes.shape({
            label: PropTypes.string,
            "page-no": PropTypes.string
          }),
          story: PropTypes.shape({
            id: PropTypes.string,
            contributors: PropTypes.arrayOf(
              PropTypes.shape({
                "role-name": PropTypes.string,
                authors: PropTypes.arrayOf(
                  PropTypes.shape({
                    name: PropTypes.string
                  })
                )
              })
            ),
            headline: PropTypes.string.isRequired,
            alternative: PropTypes.shape({
              home: PropTypes.shape({
                default: PropTypes.shape({
                  headline: PropTypes.string
                })
              })
            }),
            slug: PropTypes.string.isRequired,
            "hero-image-metadata": PropTypes.shape({
              height: PropTypes.number,
              width: PropTypes.number,
              "aspect-ratio": PropTypes.arrayOf(PropTypes.number)
            }),
            "hero-image-s3-key": PropTypes.string,
            "hero-image-caption": PropTypes.string
          })
        })
      )
    })
  })
};

export default PDFPage;
